// NEDEN kadranı — RSI(14) eğrisi + 30/70 eşik bandı (inline SVG).

interface Props {
  path: string;
  valueX: number;
  valueY: number;
  ariaLabel?: string;
}

export default function RsiEgrisi({ path, valueX, valueY, ariaLabel }: Props) {
  return (
    <div className="mt-2 -mx-1">
      <svg
        viewBox="0 0 200 80"
        className="w-full h-20 line-art"
        aria-label={ariaLabel ?? "RSI 14 günlük"}
      >
        <rect x="0" y="0" width="200" height="16" fill="#ef4444" fillOpacity="0.08" />
        <rect x="0" y="64" width="200" height="16" fill="#22c55e" fillOpacity="0.08" />
        <line
          x1="0"
          y1="16"
          x2="200"
          y2="16"
          stroke="#ef4444"
          strokeWidth="1"
          strokeDasharray="3 2"
          strokeOpacity="0.5"
        />
        <line
          x1="0"
          y1="64"
          x2="200"
          y2="64"
          stroke="#22c55e"
          strokeWidth="1"
          strokeDasharray="3 2"
          strokeOpacity="0.5"
        />
        <path d={path} fill="none" stroke="#fb923c" strokeWidth="2" />
        <circle
          cx={valueX}
          cy={valueY}
          r="4"
          fill="#fb923c"
          stroke="#0c0f16"
          strokeWidth="2"
        />
        <text
          x="2"
          y="13"
          fontSize="9"
          fill="#9ba5b5"
          fontFamily="JetBrains Mono, monospace"
        >
          70
        </text>
        <text
          x="2"
          y="77"
          fontSize="9"
          fill="#9ba5b5"
          fontFamily="JetBrains Mono, monospace"
        >
          30
        </text>
      </svg>
    </div>
  );
}
